module.exports = __webpack_public_path__ + "media/eater-type/fussy-eater-de9398c3.svg";